import * as React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { MessagePlugin } from 'tdesign-react';

export class Clip extends React.Component<React.PropsWithChildren<{ post: string }>> {
  public render() {
    return (
      <span style={{ cursor: 'pointer', display: 'flex' }}>
        <CopyToClipboard
          text={this.props.post}
          onCopy={() => {
            MessagePlugin.success(`已复制：${this.props.post}`);
          }}
        >
          {this.props.children}
        </CopyToClipboard>
      </span>
    );
  }
}
